export var SymphonyFontSizes;

(function (SymphonyFontSizes) {
  SymphonyFontSizes["bodyCopy"] = "bodyCopy";
  SymphonyFontSizes["caption"] = "caption";
  SymphonyFontSizes["ts1"] = "ts1";
  SymphonyFontSizes["ts1p5"] = "ts1p5";
  SymphonyFontSizes["ts2"] = "ts2";
  SymphonyFontSizes["ts2p5"] = "ts2p5";
  SymphonyFontSizes["ts3"] = "ts3";
  SymphonyFontSizes["ts3p5"] = "ts3p5";
  SymphonyFontSizes["ts4"] = "ts4";
  SymphonyFontSizes["ts4p5"] = "ts4p5";
  SymphonyFontSizes["ts5"] = "ts5";
  SymphonyFontSizes["ts6"] = "ts6";
  SymphonyFontSizes["ts7"] = "ts7";
  SymphonyFontSizes["ts8"] = "ts8";
})(SymphonyFontSizes || (SymphonyFontSizes = {}));

export var fontSizes = {
  caption: 10,
  ts1: 14,
  bodyCopy: 16,
  ts1p5: 18,
  ts2: 21,
  ts2p5: 26,
  ts3: 32,
  ts3p5: 40,
  ts4: 48,
  ts4p5: 54,
  ts5: 72,
  ts6: 108,
  ts7: 162,
  ts8: 243
};
export var SymphonyFontWeights;

(function (SymphonyFontWeights) {
  SymphonyFontWeights["light"] = "light";
  SymphonyFontWeights["regular"] = "regular";
  SymphonyFontWeights["medium"] = "medium";
  SymphonyFontWeights["bold"] = "bold";
})(SymphonyFontWeights || (SymphonyFontWeights = {}));

export var fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
};
export var SymphonyFonts;

(function (SymphonyFonts) {
  SymphonyFonts["system"] = "system";
  SymphonyFonts["web"] = "web";
})(SymphonyFonts || (SymphonyFonts = {}));

export var fonts = {
  system: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
  web: "aktiv-grotesk,Helvetica,Arial,sans-serif"
};